import { rootApi } from "../../api/rootApi";

export const formTemplateUsageApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getFormTemplate: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/app/formTemplate/tenant/?form_type=${params.form_type}&&user_type=${params.user_type}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    
  }),
});

export const { useGetFormTemplateMutation } = formTemplateUsageApi;
